<template>
  <v-content class="gb list-user tenants-health">
    <v-container fluid>
      <v-row align="center" justify="center">
        <v-col cols="12" md="12" class="top-container">
          <v-card
              :loading="loading"
              class="fill-width table_theme card-theme custom-container"
          >
            <v-card-title class="title_table medium-font" style="letter-spacing: normal">
              Tenants
              <v-progress-circular
                  v-if="loading"
                  indeterminate
                  color="primary"
                  style="padding: 0px 30px;"
              ></v-progress-circular>
              <v-spacer></v-spacer>
              <div class="custom-o-search-bar">
                <v-text-field
                    v-model="search"
                    placeholder="Search..."
                    single-line
                    hide-details
                    class="input_search"
                    color="#198beb"
                >
                  <img
                      :src="require('@/assets/img/search.svg')"
                      slot="prepend"
                      alt="search"
                      class="info-tooltip"
                  />
                </v-text-field>
              </div>
            </v-card-title>
            <v-divider class="ma-0 list-divider"></v-divider>

            <div class="status-stats-bar">
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Total Tenants</span>
                <span class="status-stats-bar__count">{{ tenants.length }}</span>
              </div>
              <div class="status-stats-bar__divider"></div>
              <span class="tt-host">
                <div class="status-stats-bar__item">
                  <span class="status-stats-bar__label">Healthy</span>
                  <span class="status-stats-bar__count">{{ healthyCount }}</span>
                </div>
                <span class="tt-pop tt-pop--wide">
                  <span class="tt-head">Healthy = no flags raised</span>
                  <span v-for="f in healthFlagDefs" :key="f.key" class="tt-line">
                    <strong>{{ f.label }}:</strong> {{ f.help }}
                  </span>
                </span>
              </span>
              <template v-for="flag in healthFlagDefs">
                <div :key="'div-' + flag.key" class="status-stats-bar__divider"></div>
                <div
                    :key="flag.key"
                    class="status-stats-bar__item status-stats-bar__item--clickable"
                    :class="{ 'status-stats-bar__item--active': filters.flag === flag.key }"
                    @click="toggleFlag(flag.key)"
                >
                  <v-icon class="status-stats-bar__dot" :style="{ color: flag.color }">brightness_1</v-icon>
                  <span class="status-stats-bar__label">{{ flag.label }}</span>
                  <span class="status-stats-bar__count">{{ flagCount(flag.key) }}</span>
                </div>
              </template>
            </div>
            <div class="status-stats-bar status-stats-bar--users">
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Total Users</span>
                <span class="status-stats-bar__count">{{ totalUsers }}</span>
              </div>
              <div class="status-stats-bar__divider"></div>
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Active</span>
                <span class="status-stats-bar__count">{{ totalActiveUsers }}</span>
              </div>
              <div class="status-stats-bar__divider"></div>
              <div class="status-stats-bar__item">
                <span class="status-stats-bar__label">Inactive</span>
                <span class="status-stats-bar__count">{{ totalInactiveUsers }}</span>
              </div>
              <template v-for="row in statusTotals">
                <template v-if="row.status !== 'Active'">
                  <div :key="'sdiv-' + row.status" class="status-stats-bar__divider"></div>
                  <div :key="'sitem-' + row.status" class="status-stats-bar__item">
                    <span class="status-stats-bar__label">{{ row.status }}</span>
                    <span class="status-stats-bar__count">{{ row.count }}</span>
                  </div>
                </template>
              </template>
            </div>

            <div v-if="selected.length > 0" class="bulk-bar">
              <span class="bulk-bar__count">{{ selected.length }} selected</span>
              <button type="button" class="bulk-bar__clear" @click="selected = []">Clear</button>
              <span class="bulk-bar__spacer"></span>
              <button type="button" class="bulk-bar__delete" @click="openBulkDelete">
                Delete {{ selected.length }} tenants
              </button>
            </div>

            <v-data-table
                :headers="headers"
                :items="filteredTenants"
                :search="search"
                :custom-filter="searchFilter"
                item-key="id"
                :options.sync="options"
                :mobile-breakpoint="0"
                class="agents-table"
                :footer-props="{ 'items-per-page-options': [25, 50, 100, -1] }"
            >
              <template v-slot:header.select_box>
                <input
                    type="checkbox"
                    class="td-check"
                    :title="masterCheckboxTitle"
                    :checked="masterChecked"
                    :indeterminate.prop="masterIndeterminate"
                    @change="toggleAllVisible"
                />
              </template>

              <template v-slot:item.select_box="{ item }">
                <input
                    type="checkbox"
                    class="td-check"
                    :title="'Select ' + (item.company_name || item.id)"
                    :checked="isSelected(item.id)"
                    @change="toggleOne(item)"
                />
              </template>
              <template v-slot:item.company_name="{ item }">
                <div :title="item.company_name" class="cell-sm company-cell">
                  {{ item.company_name || '(no name)' }}
                </div>
              </template>

              <template v-slot:item.owner_name="{ item }">
                <div v-if="item.owner_name" class="cell-sm owner-cell" :title="item.owner_name + (item.owner_phone ? ' · ' + item.owner_phone : '')">
                  <div class="owner-name">{{ item.owner_name }}</div>
                  <div v-if="item.owner_phone" class="owner-phone">{{ item.owner_phone }}</div>
                </div>
                <span v-else class="cell-sm" style="color: #c00;">owner_id dangling</span>
              </template>

              <template v-slot:item.active_counts="{ item }">
                <span class="tt-host">
                  <span class="user-total" :class="{ 'user-total--zero': activeTotal(item) === 0 }">
                    {{ activeTotal(item) }}
                  </span>
                  <span class="tt-pop">
                    <span class="tt-head">Active users</span>
                    <span class="tt-line">{{ activeTotal(item) === 0 ? 'none' : rolesSummary(item.counts) }}</span>
                  </span>
                </span>
              </template>

              <template v-slot:item.inactive_counts="{ item }">
                <span class="tt-host">
                  <span class="user-total user-total--muted">
                    {{ inactiveTotal(item) }}
                  </span>
                  <span class="tt-pop">
                    <span class="tt-head">Inactive users</span>
                    <span v-if="inactiveTotal(item) === 0" class="tt-line">none</span>
                    <template v-else>
                      <span v-for="(row, status) in inactiveBreakdown(item)" :key="status" class="tt-line">
                        <strong>{{ status }}:</strong> {{ rolesSummary(row) }}
                      </span>
                    </template>
                  </span>
                </span>
              </template>

              <template v-slot:item.health="{ item }">
                <span v-if="!hasAnyFlag(item)" class="health-healthy">healthy</span>
                <span v-else class="tt-host">
                  <span class="health-unhealthy">
                    unhealthy — {{ flagsShort(item) }}
                  </span>
                  <span class="tt-pop tt-pop--wide">
                    <span class="tt-head">Flags raised</span>
                    <span v-for="f in activeFlags(item)" :key="f.key" class="tt-line">
                      <strong>{{ f.label }}:</strong> {{ f.help }}
                    </span>
                  </span>
                </span>
              </template>

              <template v-slot:item.tenant_id="{ item }">
                <span class="mono" :title="item.id">{{ shortId(item.id) }}</span>
              </template>

              <template v-slot:item.actions="{ item }">
                <button
                    type="button"
                    class="tenant-delete-btn"
                    :title="'Delete tenant ' + (item.company_name || item.id)"
                    @click="openDelete(item)"
                >
                  Delete
                </button>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-snackbar v-model="error.show" color="error" :timeout="5000" top>
      {{ error.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="error.show = false">Close</v-btn>
      </template>
    </v-snackbar>

    <v-snackbar v-model="success.show" color="success" :timeout="6000" top>
      {{ success.message }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="success.show = false">Close</v-btn>
      </template>
    </v-snackbar>

    <div v-if="deleteModal.show" class="td-modal-backdrop" @click.self="closeDelete">
      <div class="td-modal" role="dialog" aria-modal="true" aria-labelledby="td-modal-title">
        <div class="td-modal__head">
          <h2 id="td-modal-title">Delete tenant</h2>
          <button type="button" class="td-modal__close" @click="closeDelete" aria-label="Close">×</button>
        </div>

        <div class="td-modal__body">
          <p class="td-warn">
            <strong>This is permanent.</strong> The tenant, every chat, file, and update under it,
            and all users that belong only to this tenant will be hard-deleted from
            <strong>{{ envLabel }}</strong>.
            Users who also belong to another tenant will keep their account.
          </p>

          <div class="td-target">
            <div class="td-target__row">
              <span class="td-target__label">Company</span>
              <span class="td-target__val">{{ deleteModal.tenant.company_name || '(no name)' }}</span>
            </div>
            <div class="td-target__row">
              <span class="td-target__label">Tenant&nbsp;ID</span>
              <span class="td-target__val mono">{{ deleteModal.tenant.id }}</span>
            </div>
            <div v-if="deleteModal.tenant.owner_name" class="td-target__row">
              <span class="td-target__label">Owner</span>
              <span class="td-target__val">
                {{ deleteModal.tenant.owner_name }}
                <span v-if="deleteModal.tenant.owner_phone" class="td-target__sub">· {{ deleteModal.tenant.owner_phone }}</span>
              </span>
            </div>
          </div>

          <div v-if="deleteModal.previewLoading" class="td-preview td-preview--loading">
            Loading footprint…
          </div>
          <div v-else-if="deleteModal.preview" class="td-preview">
            <div class="td-preview__title">What will be deleted</div>
            <ul class="td-preview__list">
              <li><strong>{{ previewBreakdown.users }}</strong> users
                <span v-if="previewBreakdown.userBreakdown" class="td-preview__sub">({{ previewBreakdown.userBreakdown }})</span>
              </li>
              <li><strong>{{ deleteModal.preview.counts.chats }}</strong> chats <span class="td-preview__sub">(messages cascade with the chat)</span></li>
              <li><strong>{{ deleteModal.preview.counts.files }}</strong> files</li>
              <li><strong>{{ deleteModal.preview.counts.updates }}</strong> updates</li>
              <li><strong>{{ deleteModal.preview.counts.referrals }}</strong> referrals</li>
              <li><strong>{{ deleteModal.preview.counts.ai_contexts }}</strong> AI contexts</li>
              <li><strong>{{ deleteModal.preview.counts.calls }}</strong> calls</li>
              <li v-if="deleteModal.preview.counts.market_zips > 0">
                <strong>{{ deleteModal.preview.counts.market_zips }}</strong> market ZIPs <span class="td-preview__sub">(released back to available)</span>
              </li>
            </ul>
          </div>

          <label class="td-field">
            <span class="td-field__label">
              <template v-if="isZombieTenant">
                This tenant has no company name (zombie record). Type
                <span class="mono td-field__hint">DELETE</span> to confirm cleanup.
              </template>
              <template v-else>
                Type the exact company name to confirm:
                <span class="mono td-field__hint">{{ deleteModal.tenant.company_name }}</span>
              </template>
            </span>
            <input
                v-model="deleteModal.confirmName"
                type="text"
                class="td-input"
                :disabled="deleteModal.submitting"
                autocomplete="off"
                spellcheck="false"
            />
          </label>

          <label class="td-field">
            <span class="td-field__label">Reason (optional, captured in audit log)</span>
            <textarea
                v-model="deleteModal.reason"
                class="td-textarea"
                rows="2"
                :disabled="deleteModal.submitting"
                placeholder="e.g. test/bogus tenant cleanup"
            />
          </label>

          <div v-if="deleteModal.submitting" class="td-progress">
            Deleting tenant… this can take a minute on large tenants.
          </div>
          <div v-if="deleteModal.errorMessage" class="td-error">{{ deleteModal.errorMessage }}</div>
        </div>

        <div class="td-modal__foot">
          <button type="button" class="td-btn td-btn--ghost" @click="closeDelete" :disabled="deleteModal.submitting">Cancel</button>
          <button
              type="button"
              class="td-btn td-btn--danger"
              :disabled="!canSubmitDelete || deleteModal.submitting"
              @click="confirmDelete"
          >
            {{ deleteModal.submitting ? 'Deleting…' : 'Delete tenant permanently' }}
          </button>
        </div>
      </div>
    </div>

    <div v-if="bulkDeleteModal.show" class="td-modal-backdrop" @click.self="closeBulkDelete">
      <div class="td-modal" role="dialog" aria-modal="true" aria-labelledby="bd-modal-title">
        <div class="td-modal__head">
          <h2 id="bd-modal-title">Delete {{ selected.length }} tenants</h2>
          <button type="button" class="td-modal__close" @click="closeBulkDelete" aria-label="Close">×</button>
        </div>

        <div class="td-modal__body">
          <p class="td-warn">
            <strong>This is permanent.</strong> All {{ selected.length }} selected tenants and their
            data (chats, files, updates, AI contexts, calls, referrals) will be hard-deleted from
            <strong>{{ envLabel }}</strong>. Users that belong to ANY other tenant will keep their
            account; users that belong only to one of these will be fully removed.
          </p>

          <div class="td-target">
            <div class="bulk-list">
              <div v-for="t in selected" :key="t.id" class="bulk-list__row">
                <span class="bulk-list__name">{{ t.company_name || '(no name)' }}</span>
                <span class="bulk-list__owner">{{ t.owner_name || '(no owner)' }}</span>
                <span class="bulk-list__id mono">{{ shortId(t.id) }}</span>
              </div>
            </div>
          </div>

          <label class="td-field">
            <span class="td-field__label">
              Type <span class="mono td-field__hint">DELETE-ALL</span> to confirm:
            </span>
            <input
                v-model="bulkDeleteModal.confirmText"
                type="text"
                class="td-input"
                :disabled="bulkDeleteModal.submitting"
                autocomplete="off"
                spellcheck="false"
            />
          </label>

          <label class="td-field">
            <span class="td-field__label">Reason (optional, captured per-tenant in audit log)</span>
            <textarea
                v-model="bulkDeleteModal.reason"
                class="td-textarea"
                rows="2"
                :disabled="bulkDeleteModal.submitting"
                placeholder="e.g. test/bogus tenant cleanup"
            />
          </label>

          <div v-if="bulkDeleteModal.submitting" class="td-progress">
            Deleting tenant {{ bulkDeleteModal.progressDone + 1 }} of {{ bulkDeleteModal.progressTotal }}…
          </div>
          <div v-if="bulkDeleteModal.results.length && !bulkDeleteModal.submitting" class="td-preview">
            <div class="td-preview__title">Results</div>
            <ul class="td-preview__list">
              <li v-for="r in bulkDeleteModal.results" :key="r.id">
                <span :class="r.ok ? 'health-healthy' : 'health-unhealthy'">{{ r.ok ? 'ok' : 'failed' }}</span>
                {{ r.name }} <span class="td-preview__sub">{{ r.message }}</span>
              </li>
            </ul>
          </div>
          <div v-if="bulkDeleteModal.errorMessage" class="td-error">{{ bulkDeleteModal.errorMessage }}</div>
        </div>

        <div class="td-modal__foot">
          <!-- After completion the run is final — only Close remains. -->
          <template v-if="bulkDeleteModal.completed">
            <button type="button" class="td-btn td-btn--danger" @click="closeBulkDelete">Close</button>
          </template>
          <template v-else>
            <button type="button" class="td-btn td-btn--ghost" @click="closeBulkDelete" :disabled="bulkDeleteModal.submitting">
              Cancel
            </button>
            <button
                type="button"
                class="td-btn td-btn--danger"
                :disabled="!canSubmitBulkDelete || bulkDeleteModal.submitting"
                @click="confirmBulkDelete"
            >
              {{ bulkDeleteModal.submitting ? 'Deleting…' : ('Delete ' + selected.length + ' tenants') }}
            </button>
          </template>
        </div>
      </div>
    </div>
  </v-content>
</template>

<script>
import axios from 'axios';
import { firestore, firebase, auth } from '@/config/firebase';
import { mapState } from 'vuex';
import config from '@/config/constants';
import { humanizeAxiosError } from '@/views/owner/markets/markets_api';
import { ensurePassphrase } from '@/util/super_admin_passphrase';
import { runBulkDeleteCascade } from '@/util/bulk_delete_tenants';

const HEALTH_FLAGS = [
  { key: 'orphan_candidate', label: 'Orphan candidates', short: 'orphan', color: '#e74c3c',
    help: 'Tenant has zero real users and the owner is actively registered as vendor/employee/client elsewhere — likely a mistaken owner-signup.' },
  { key: 'no_agents', label: 'No agents', short: 'no agents', color: '#e67e22',
    help: 'Tenant has no users with role agent and fewer than 2 real users total — account is effectively empty.' },
  { key: 'role_mismatch', label: 'Role mismatch', short: 'role', color: '#c0392b',
    help: 'Top-level tenants/{id}.user_role disagrees with the owner\'s tenants_list.role entry.' },
  { key: 'owner_id_dangling', label: 'Owner dangling', short: 'dangling', color: '#c0392b',
    help: 'tenants/{id}.owner_id points to a global user doc that no longer exists.' },
];

export default {
  name: 'TenantsList',

  data() {
    return {
      loading: true,
      tenants: [],
      search: '',
      options: { itemsPerPage: 50 },
      filters: { flag: null },
      selected: [],
      bulkDeleteModal: {
        show: false,
        confirmText: '',
        reason: '',
        submitting: false,
        completed: false,
        progressDone: 0,
        progressTotal: 0,
        results: [],
        errorMessage: '',
      },
      error: { show: false, message: '' },
      success: { show: false, message: '' },
      deleteModal: {
        show: false,
        tenant: { id: '', company_name: '', owner_name: '', owner_phone: '' },
        confirmName: '',
        reason: '',
        preview: null,
        previewLoading: false,
        submitting: false,
        errorMessage: '',
      },
      headers: [
        { text: '', value: 'select_box', sortable: false, width: '36px', align: 'center', cellClass: 'col-select' },
        { text: 'COMPANY NAME', value: 'company_name', sortable: true, width: '22%', cellClass: 'col-company' },
        { text: 'OWNER', value: 'owner_name', sortable: true, width: '22%', cellClass: 'col-owner' },
        { text: 'ACTIVE', value: 'active_counts', sortable: true, width: '8%', align: 'center' },
        { text: 'INACTIVE', value: 'inactive_counts', sortable: true, width: '8%', align: 'center' },
        { text: 'HEALTH', value: 'health', sortable: false, width: '20%', cellClass: 'col-health' },
        { text: 'ID', value: 'tenant_id', sortable: false, width: '13%', cellClass: 'col-id' },
        { text: '', value: 'actions', sortable: false, width: '7%', align: 'center', cellClass: 'col-actions' },
      ],
      healthFlagDefs: HEALTH_FLAGS,
    };
  },

  computed: {
    ...mapState({
      agentsByStatusGlobal: state => state.Authenticate.agents_by_status || {},
      vendorsByStatusGlobal: state => state.Authenticate.vendors_by_status || {},
      clientsByStatusGlobal: state => state.Authenticate.clients_by_status || {},
    }),
    filteredTenants() {
      if (!this.filters.flag) return this.tenants;
      return this.tenants.filter(t => t.flags[this.filters.flag]);
    },
    healthyCount() {
      return this.tenants.filter(t => !this.hasAnyFlag(t)).length;
    },
    // Platform totals read from the Vuex state populated by authenticate.store
    // the same state the Company List modal uses — guarantees the numbers
    // on both pages match because they share one source of truth.
    mergedStatusTotals() {
      const merged = {};
      const sources = [this.agentsByStatusGlobal, this.vendorsByStatusGlobal, this.clientsByStatusGlobal];
      for (const src of sources) {
        for (const [status, count] of Object.entries(src || {})) {
          merged[status] = (merged[status] || 0) + count;
        }
      }
      return merged;
    },
    totalActiveUsers() {
      return this.mergedStatusTotals.Active || 0;
    },
    totalInactiveUsers() {
      let sum = 0;
      for (const [status, count] of Object.entries(this.mergedStatusTotals)) {
        if (status !== 'Active') sum += count;
      }
      return sum;
    },
    totalUsers() {
      return this.totalActiveUsers + this.totalInactiveUsers;
    },
    envLabel() {
      // Pulled from VUE_APP_FIREBASE_PROJECT_ID — gives operators an
      // unambiguous reminder of which project they're about to wipe.
      const pid = config.firebaseConfig && config.firebaseConfig.projectId;
      return pid || config.api_url || 'this environment';
    },
    canSubmitDelete() {
      const target = (this.deleteModal.tenant.company_name || '').trim().toLowerCase();
      const typed = (this.deleteModal.confirmName || '').trim().toLowerCase();
      // Zombie tenants (no company_name, typically created by a stray
      // trigger writing back after a partial delete) accept the literal
      // token "DELETE" instead.
      if (target.length === 0) return typed === 'delete';
      return typed === target;
    },
    isZombieTenant() {
      return !((this.deleteModal.tenant.company_name || '').trim());
    },
    canSubmitBulkDelete() {
      // Once the run completes, the Delete button is replaced with
      // Close — so this is no longer a re-submit gate.
      if (this.bulkDeleteModal.completed) return false;
      return this.selected.length > 0
        && (this.bulkDeleteModal.confirmText || '').trim().toUpperCase() === 'DELETE-ALL';
    },
    masterChecked() {
      const visible = this.filteredTenants;
      if (visible.length === 0) return false;
      return visible.every(t => this.isSelected(t.id));
    },
    masterIndeterminate() {
      const visible = this.filteredTenants;
      if (visible.length === 0) return false;
      const someSelected = visible.some(t => this.isSelected(t.id));
      return someSelected && !this.masterChecked;
    },
    masterCheckboxTitle() {
      if (this.masterChecked) return 'Deselect all visible';
      if (this.masterIndeterminate) return 'Some selected — click to select all visible';
      return 'Select all visible';
    },
    previewBreakdown() {
      const p = this.deleteModal.preview;
      if (!p) return { users: 0, userBreakdown: '' };
      const c = p.counts || {};
      const total = c.total_users || 0;
      const parts = [];
      const labels = { agent: 'agent', vendor: 'vendor', employee: 'employee', client: 'homeowner', owner: 'owner', super_user: 'super_user (HQ — kept)' };
      for (const role of Object.keys(labels)) {
        if (c[role]) parts.push(`${c[role]} ${labels[role]}`);
      }
      if (c.unknown) parts.push(`${c.unknown} unknown`);
      return { users: total, userBreakdown: parts.join(' · ') };
    },
    statusTotals() {
      const order = ['Active', 'Onboarding', 'Signed Up', 'Invited', 'Cancelled', 'Deleted'];
      const totals = this.mergedStatusTotals;
      const seen = new Set();
      const rows = [];
      for (const s of order) {
        if (totals[s] !== undefined) { rows.push({ status: s, count: totals[s] }); seen.add(s); }
      }
      for (const s of Object.keys(totals)) {
        if (!seen.has(s)) rows.push({ status: s, count: totals[s] });
      }
      return rows;
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      this.loading = true;
      try {
        const tenantsSnap = await firestore.collection('tenants').get();
        const tenantDocs = tenantsSnap.docs.map(d => ({ id: d.id, ...d.data() }));

        const ownerIds = [...new Set(tenantDocs.map(t => t.owner_id).filter(Boolean))];
        const globalUsers = await this.batchGetUsers(ownerIds);

        const userCountPromises = tenantDocs.map(async (t) => {
          try {
            const usersSnap = await firestore.collection('tenants').doc(t.id).collection('users').get();
            const emptyCounts = () => ({ agent: 0, owner: 0, vendor: 0, employee: 0, client: 0, unknown: 0 });
            const counts = emptyCounts();
            const byStatus = { Active: emptyCounts(), Invited: emptyCounts(), Onboarding: emptyCounts(), 'Signed Up': emptyCounts(), Deleted: emptyCounts(), Cancelled: emptyCounts(), Other: emptyCounts() };
            for (const userDoc of usersSnap.docs) {
              const data = userDoc.data();
              const role = (data.user_role || 'unknown').toLowerCase();
              // Skip super_user sub-docs entirely — they're Kiey HQ access records,
              // not real users of the tenant.
              if (role === 'super_user') continue;
              const status = data.status || 'Other';
              const bucket = byStatus[status] ? status : 'Other';
              if (byStatus[bucket][role] !== undefined) byStatus[bucket][role]++;
              else byStatus[bucket].unknown++;
              if (status === 'Active') {
                if (counts[role] !== undefined) counts[role]++;
                else counts.unknown++;
              }
            }
            return { id: t.id, counts, byStatus, total_users: usersSnap.docs.length };
          } catch (err) {
            console.warn('[Tenants] failed to count users for tenant', t.id, err);
            return { id: t.id, counts: { agent: 0, owner: 0, vendor: 0, employee: 0, client: 0, unknown: 0 }, byStatus: {}, total_users: 0 };
          }
        });
        const userCountResults = await Promise.all(userCountPromises);
        const countsById = {};
        for (const r of userCountResults) countsById[r.id] = r;

        const enriched = tenantDocs.map(t => this.enrichTenant(t, globalUsers, countsById[t.id]));
        this.tenants = enriched;
      } catch (err) {
        console.error('[Tenants] load failed:', err);
        this.error = { show: true, message: 'Failed to load tenants: ' + (err.message || err) };
      } finally {
        this.loading = false;
      }
    },

    async batchGetUsers(ownerIds) {
      const map = {};
      if (ownerIds.length === 0) return map;
      const batches = [];
      for (let i = 0; i < ownerIds.length; i += 30) {
        const batch = ownerIds.slice(i, i + 30);
        batches.push(
            firestore.collection('users')
                .where(firebase.firestore.FieldPath.documentId(), 'in', batch)
                .get()
        );
      }
      const results = await Promise.all(batches);
      for (const snap of results) {
        for (const doc of snap.docs) {
          map[doc.id] = { id: doc.id, ...doc.data() };
        }
      }
      return map;
    },

    enrichTenant(t, globalUsers, userCountData) {
      const counts = userCountData ? userCountData.counts : { agent: 0, owner: 0, vendor: 0, employee: 0, client: 0, unknown: 0 };
      const byStatus = userCountData ? userCountData.byStatus : {};
      const total_users = userCountData ? userCountData.total_users : 0;

      const ownerGlobal = t.owner_id ? globalUsers[t.owner_id] : null;
      const owner_name = ownerGlobal ? `${ownerGlobal.first_name || ''} ${ownerGlobal.last_name || ''}`.trim() : '';
      const owner_phone = ownerGlobal ? (ownerGlobal.phone_number || '') : '';

      const tenant_doc_role = (t.user_role || '').toLowerCase();

      let owner_global_role = '';
      if (ownerGlobal && Array.isArray(ownerGlobal.tenants_list)) {
        const entry = ownerGlobal.tenants_list.find(x => x.tenant_id === t.id);
        if (entry) owner_global_role = (entry.role || '').toLowerCase();
      }

      const role_mismatch =
          !!tenant_doc_role && !!owner_global_role && tenant_doc_role !== owner_global_role;

      const owner_id_dangling = !!t.owner_id && !ownerGlobal;

      // Exclude super_user sub-docs — there's only one real super_user in Kiey
      // (the Kiey HQ account) and it's stamped into every tenant's users
      // subcollection by createUserAdminForTenantIfNotExists as an access record.
      // Also exclude 'owner' sub-docs: the tenant IS the owner, so the owner
      // sub-doc is a self-reference, not a "user" of the tenant. This matches
      // the Company List modal's counting so totals line up across the app.
      const real_user_count = counts.agent + counts.vendor + counts.employee + counts.client;
      const no_agents = counts.agent === 0 && real_user_count < 2;
      const orphan_candidate =
          real_user_count <= 1 &&
          counts.agent === 0 &&
          this.ownerHasNonOwnerRoleElsewhere(ownerGlobal, t.id);

      const stripe_linked_no_billing = !!t.customer_id && t.billing_active !== true;

      return {
        id: t.id,
        company_name: t.company_name || '',
        owner_id: t.owner_id || '',
        owner_name,
        owner_phone,
        tenant_doc_role,
        owner_global_role,
        billing_active: t.billing_active === true,
        customer_id: t.customer_id || '',
        created_at: this.extractCreatedAt(t),
        counts,
        byStatus,
        total_users,
        real_user_count,
        flags: {
          orphan_candidate,
          no_agents,
          role_mismatch,
          stripe_linked_no_billing,
          owner_id_dangling,
        },
      };
    },

    ownerHasNonOwnerRoleElsewhere(ownerGlobal, currentTenantId) {
      if (!ownerGlobal || !Array.isArray(ownerGlobal.tenants_list)) return false;
      return ownerGlobal.tenants_list.some(e =>
          e.tenant_id !== currentTenantId &&
          e.status !== 'inactive' &&
          ['vendor', 'employee', 'client'].includes((e.role || '').toLowerCase())
      );
    },

    extractCreatedAt(t) {
      const candidates = [t.created_at, t.created_date, t.creation_date];
      for (const c of candidates) {
        if (!c) continue;
        if (typeof c.toDate === 'function') return c.toDate();
        if (c instanceof Date) return c;
        if (typeof c === 'string' || typeof c === 'number') {
          const d = new Date(c);
          if (!isNaN(d.getTime())) return d;
        }
        if (c.seconds) return new Date(c.seconds * 1000);
      }
      return null;
    },

    formatDate(d) {
      if (!d) return '—';
      return d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' });
    },

    shortId(id) {
      if (!id) return '';
      return id.length > 8 ? id.substring(0, 8) + '…' : id;
    },

    userCountsTitle(item) {
      return this.rolesSummary(item.counts);
    },

    rolesSummary(counts) {
      if (!counts) return '';
      const parts = [];
      if (counts.agent) parts.push(`${counts.agent} agent`);
      if (counts.vendor) parts.push(`${counts.vendor} vendor`);
      if (counts.employee) parts.push(`${counts.employee} employee`);
      if (counts.client) parts.push(`${counts.client} homeowner`);
      if (parts.length === 0) return 'none';
      return parts.join(' · ');
    },

    roleRows(counts) {
      if (!counts) return [];
      const defs = [
        { role: 'agent',    label: 'agent',    color: '#1f618d' },
        { role: 'vendor',   label: 'vendor',   color: '#196f3d' },
        { role: 'employee', label: 'employee', color: '#196f3d' },
        { role: 'client',   label: 'homeowner',   color: '#922b21' },
        { role: 'owner',    label: 'owner',    color: '#7d6608' },
      ];
      return defs
          .filter(d => counts[d.role] > 0)
          .map(d => ({ ...d, count: counts[d.role] }));
    },

    activeTotal(item) {
      const c = item.counts || {};
      return (c.agent || 0) + (c.vendor || 0) + (c.employee || 0) + (c.client || 0);
    },

    inactiveRoles(item) {
      const totals = { agent: 0, vendor: 0, employee: 0, client: 0 };
      const bs = item.byStatus || {};
      for (const [status, row] of Object.entries(bs)) {
        if (status === 'Active') continue;
        for (const role of Object.keys(totals)) {
          totals[role] += row[role] || 0;
        }
      }
      return totals;
    },

    inactiveTotal(item) {
      const r = this.inactiveRoles(item);
      return r.agent + r.vendor + r.employee + r.client;
    },

    inactiveBreakdown(item) {
      const out = {};
      const bs = item.byStatus || {};
      for (const [status, row] of Object.entries(bs)) {
        if (status === 'Active') continue;
        const t = (row.agent || 0) + (row.vendor || 0) + (row.employee || 0) + (row.client || 0);
        if (t > 0) out[status] = row;
      }
      return out;
    },

    hasAnyFlag(item) {
      if (!item || !item.flags) return false;
      return Object.values(item.flags).some(v => v);
    },

    flagsShort(item) {
      if (!item || !item.flags) return '';
      return HEALTH_FLAGS.filter(f => item.flags[f.key]).map(f => f.short).join(', ');
    },

    activeFlags(item) {
      if (!item || !item.flags) return [];
      return HEALTH_FLAGS.filter(f => item.flags[f.key]);
    },

    flagCount(key) {
      return this.tenants.filter(t => t.flags[key]).length;
    },

    toggleFlag(key) {
      this.filters.flag = this.filters.flag === key ? null : key;
    },

    searchFilter(value, search, item) {
      if (!search) return true;
      const q = search.toLowerCase();
      return (
          (item.company_name || '').toLowerCase().includes(q) ||
          (item.owner_name || '').toLowerCase().includes(q) ||
          (item.owner_phone || '').toLowerCase().includes(q) ||
          (item.id || '').toLowerCase().includes(q)
      );
    },

    async authHeaders() {
      const headers = {};
      const fbUser = auth && auth.currentUser;
      if (fbUser) {
        headers['X-Firebase-Token'] = await fbUser.getIdToken();
      }
      return headers;
    },

    openDelete(item) {
      this.deleteModal = {
        show: true,
        tenant: {
          id: item.id,
          company_name: item.company_name || '',
          owner_name: item.owner_name || '',
          owner_phone: item.owner_phone || '',
        },
        confirmName: '',
        reason: '',
        preview: null,
        previewLoading: true,
        submitting: false,
        errorMessage: '',
      };
      this.loadDeletePreview(item.id);
    },

    closeDelete() {
      if (this.deleteModal.submitting) return;
      this.deleteModal.show = false;
    },

    async loadDeletePreview(tenantId) {
      try {
        const headers = await this.authHeaders();
        const res = await axios.get(
            `${config.api_url}super_admin/tenants/${tenantId}/delete-preview`,
            { headers },
        );
        // Guard against late responses for a tenant the operator already
        // closed/swapped — we'd otherwise overwrite a fresh modal state
        // with stale counts.
        if (this.deleteModal.tenant.id === tenantId && this.deleteModal.show) {
          this.deleteModal.preview = res.data && res.data.data;
        }
      } catch (e) {
        if (this.deleteModal.tenant.id === tenantId && this.deleteModal.show) {
          this.deleteModal.errorMessage = 'Failed to load preview: ' + humanizeAxiosError(e);
        }
      } finally {
        if (this.deleteModal.tenant.id === tenantId) {
          this.deleteModal.previewLoading = false;
        }
      }
    },

    async confirmDelete() {
      if (!this.canSubmitDelete) return;
      const tenantId = this.deleteModal.tenant.id;
      const companyName = this.deleteModal.tenant.company_name;
      const isZombie = !companyName || !companyName.trim();
      const confirmString = isZombie ? 'DELETE' : companyName;
      const displayName = isZombie ? `(zombie ${tenantId.substring(0, 8)})` : companyName;

      // Prompt for the destructive passphrase up-front, while we still
      // have a user gesture. Browsers (Chrome especially) block
      // window.prompt() inside async axios interceptors, which is why
      // we don't rely on the interceptor to fire it for destructive ops.
      const passphrase = ensurePassphrase();
      if (!passphrase) {
        this.deleteModal.errorMessage =
          'Super-admin passphrase required to perform destructive actions.';
        return;
      }

      this.deleteModal.submitting = true;
      this.deleteModal.errorMessage = '';
      try {
        const headers = await this.authHeaders();
        const res = await axios.post(
            `${config.api_url}super_admin/tenants/${tenantId}/delete`,
            {
              confirm_company_name: confirmString,
              reason: this.deleteModal.reason || null,
            },
            { headers },
        );
        const data = (res.data && res.data.data) || {};
        const failures = (data.user_failures || []).length;
        const msg = `Deleted "${displayName}". Removed ${data.deleted_users || 0} users` +
            (data.global_users_wiped ? ` (${data.global_users_wiped} fully wiped)` : '') +
            (data.market_zips_released ? `, released ${data.market_zips_released} ZIPs` : '') +
            (failures ? ` — ${failures} per-user issue(s), see audit log` : '') + '.';
        this.success = { show: true, message: msg };
        this.deleteModal.show = false;
        // Drop the deleted row locally so the table updates instantly,
        // then re-pull to refresh stats. Avoids a full table flicker.
        this.tenants = this.tenants.filter(t => t.id !== tenantId);
        this.loadData();
      } catch (e) {
        this.deleteModal.errorMessage = 'Delete failed: ' + humanizeAxiosError(e);
      } finally {
        this.deleteModal.submitting = false;
      }
    },

    isSelected(id) {
      return this.selected.some(t => t.id === id);
    },

    toggleOne(item) {
      if (this.isSelected(item.id)) {
        this.selected = this.selected.filter(t => t.id !== item.id);
      } else {
        this.selected = this.selected.concat([item]);
      }
    },

    toggleAllVisible() {
      const visible = this.filteredTenants;
      if (this.masterChecked) {
        // Currently all visible are selected → deselect ONLY the visible
        // ones (keeping any selections that were filtered out by search).
        const visibleIds = new Set(visible.map(t => t.id));
        this.selected = this.selected.filter(t => !visibleIds.has(t.id));
      } else {
        // Add every visible row that isn't already selected.
        const selectedIds = new Set(this.selected.map(t => t.id));
        const toAdd = visible.filter(t => !selectedIds.has(t.id));
        this.selected = this.selected.concat(toAdd);
      }
    },

    openBulkDelete() {
      this.bulkDeleteModal = {
        show: true,
        confirmText: '',
        reason: '',
        submitting: false,
        completed: false,
        progressDone: 0,
        progressTotal: this.selected.length,
        results: [],
        errorMessage: '',
      };
    },

    closeBulkDelete() {
      if (this.bulkDeleteModal.submitting) return;
      this.bulkDeleteModal.show = false;
      // After a finished run, also reset selection so the bulk-bar
      // doesn't keep showing a stale "N selected" for already-deleted
      // rows.
      if (this.bulkDeleteModal.results.length) {
        const failedIds = new Set(
          this.bulkDeleteModal.results.filter(r => !r.ok).map(r => r.id),
        );
        // Keep failures selected so the operator can see and retry; drop successes.
        this.selected = this.selected.filter(t => failedIds.has(t.id));
      }
    },

    async confirmBulkDelete() {
      if (!this.canSubmitBulkDelete) return;
      // Prompt for the destructive passphrase ONCE up-front; cached in
      // sessionStorage so subsequent calls in the loop reuse it.
      const passphrase = ensurePassphrase();
      if (!passphrase) {
        this.bulkDeleteModal.errorMessage =
          'Super-admin passphrase required to perform destructive actions.';
        return;
      }

      this.bulkDeleteModal.submitting = true;
      this.bulkDeleteModal.errorMessage = '';
      this.bulkDeleteModal.results = [];
      this.bulkDeleteModal.progressDone = 0;

      const headers = await this.authHeaders();
      const { okCount, failCount } = await runBulkDeleteCascade({
        targets: this.selected.slice(),
        apiBaseUrl: config.api_url,
        headers,
        reason: this.bulkDeleteModal.reason || null,
        axiosPost: axios.post.bind(axios),
        humanizeAxiosError,
        callbacks: {
          onResult: (r) => {
            this.bulkDeleteModal.results.push(r);
            if (r.ok) {
              // Drop successes from both the rendered list and the
              // live selection so a stray re-click never re-attempts.
              this.tenants = this.tenants.filter(x => x.id !== r.id);
              this.selected = this.selected.filter(x => x.id !== r.id);
            }
          },
          onProgress: (done) => {
            this.bulkDeleteModal.progressDone = done;
          },
        },
      });

      this.bulkDeleteModal.submitting = false;
      this.bulkDeleteModal.completed = true;
      this.success = {
        show: true,
        message: `Bulk delete done: ${okCount} succeeded` + (failCount ? `, ${failCount} failed (see modal)` : ''),
      };
      // Re-pull to keep platform stats fresh.
      this.loadData();
    },
  },
};
</script>

<style lang="scss" scoped>
.tenants-health {
  width: 100%;

  .custom-container {
    max-width: none !important;
    width: 100% !important;
    margin: 0 12px 50px 12px !important;
  }

  ::v-deep .v-data-table__wrapper {
    overflow-x: auto;
  }

  ::v-deep table {
    width: 100% !important;
  }

  ::v-deep thead th {
    white-space: nowrap;
    font-size: 11px !important;
    padding: 6px 10px !important;
  }

  ::v-deep tbody td {
    font-size: 12px;
    padding: 8px 10px !important;
    vertical-align: middle;
  }

  ::v-deep td.col-company,
  ::v-deep td.col-owner,
  ::v-deep td.col-health {
    overflow: hidden;
  }

  ::v-deep td.col-company .company-cell,
  ::v-deep td.col-owner .owner-cell {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .company-cell {
    font-family: monospace;
    font-size: 11px;
    color: #333;
  }

  .owner-cell {
    line-height: 1.2;
  }

  .owner-name {
    font-family: monospace;
    font-size: 11px;
    color: #333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .owner-phone {
    font-family: monospace;
    font-size: 10px;
    color: #888;
  }

  .status-stats-bar {
    display: flex;
    align-items: center;
    padding: 12px 20px;
    gap: 16px;
    flex-wrap: wrap;
    border-bottom: 1px solid #eee;
  }

  .status-stats-bar--users {
    background: #fafbfd;
  }

  .status-stats-bar__item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
  }

  .status-stats-bar__item--clickable {
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 4px;
    transition: background 0.15s;
  }

  .status-stats-bar__item--clickable:hover {
    background: #f5f5f5;
  }

  .status-stats-bar__item--active {
    background: #061d47;
    color: white;
  }

  .status-stats-bar__divider {
    width: 1px;
    height: 20px;
    background: #ddd;
  }

  .status-stats-bar__label {
    color: #666;
  }

  .status-stats-bar__item--active .status-stats-bar__label {
    color: white;
  }

  .status-stats-bar__count {
    font-weight: 600;
  }

  .status-stats-bar__dot {
    font-size: 10px !important;
  }

  .user-total {
    font-family: monospace;
    font-size: 12px;
    font-weight: 600;
    color: #061d47;
  }

  .user-total--zero {
    color: #c00;
  }

  .user-total--muted {
    color: #888;
    font-weight: 500;
  }

  .cell-sm {
    font-family: monospace;
    font-size: 11px;
    color: #333;
  }

  .cell-sm-muted {
    font-family: monospace;
    font-size: 11px;
    color: #888;
    margin-left: 6px;
  }

  .health-healthy {
    color: #2ecc71;
    font-weight: 600;
    font-size: 12px;
  }

  .health-unhealthy {
    color: #c0392b;
    font-weight: 600;
    font-size: 12px;
  }

  .role-mismatch {
    color: #c0392b;
    font-weight: 600;
  }

  .mono {
    font-family: monospace;
    font-size: 11px;
    color: #888;
  }

  .text-truncate-cell {
    display: inline-block;
    max-width: 240px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
}

.tt-host {
  position: relative;
  display: inline-block;
}

.tt-pop {
  display: none;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 4px;
  background: #fff;
  border: 1px solid #d7dbe0;
  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  padding: 4px 6px;
  font-size: 9px;
  line-height: 1.3;
  white-space: nowrap;
  z-index: 1000;
  pointer-events: none;
  min-width: 80px;
}

.tt-host:hover .tt-pop {
  display: block;
}

.tt-pop--wide {
  white-space: normal;
  width: 240px;
  max-width: 240px;
}

.tt-pop--wide .tt-line {
  padding-top: 2px;
}

.tt-pop .tt-head {
  display: block;
  font-weight: 700;
  color: #061d47;
  font-size: 9px;
}

.tt-pop .tt-line {
  display: block;
  color: #333;
  font-weight: 400;
  font-size: 9px;
}

.tt-pop .tt-line strong {
  font-weight: 600;
  color: #061d47;
}

/* Plain-HTML square checkbox.
 * One <input>, custom-painted via appearance:none. No span overlay,
 * no absolute positioning — what you see IS the input box, so it
 * can't drift apart from its own click target. */
input.td-check {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  width: 18px;
  height: 18px;
  min-width: 18px;
  min-height: 18px;
  margin: 0;
  padding: 0;
  border: 1.5px solid #888;
  border-radius: 0;
  background: #fff;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
  transition: background-color 0.12s ease, border-color 0.12s ease;
  flex-shrink: 0;
}
input.td-check:hover {
  border-color: #061d47;
}
input.td-check:checked {
  background: #061d47;
  border-color: #061d47;
}
input.td-check:checked::after {
  content: '';
  position: absolute;
  left: 5px;
  top: 1px;
  width: 4px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
input.td-check:indeterminate {
  background: #061d47;
  border-color: #061d47;
}
input.td-check:indeterminate::after {
  content: '';
  position: absolute;
  left: 3px;
  right: 3px;
  top: 7px;
  height: 2px;
  background: #fff;
}
input.td-check:focus-visible {
  outline: 2px solid #061d47;
  outline-offset: 2px;
}

::v-deep td.col-select,
::v-deep th.col-select {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  padding: 0 8px !important;
  text-align: center !important;
  vertical-align: middle !important;
}
/* Vuetify's v-data-table renders the header cell as
 * <th class="text-start sortable">; the cellClass we set only lands on
 * <td>, not <th>. Match by data-column-value too so the header cell
 * gets the same width/center treatment. */
::v-deep thead th:first-child {
  width: 44px !important;
  min-width: 44px !important;
  max-width: 44px !important;
  padding: 0 8px !important;
  text-align: center !important;
  vertical-align: middle !important;
}

.bulk-bar {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff5f3;
  border: 1px solid #f1c4bd;
  border-radius: 6px;
  padding: 10px 14px;
  margin: 0 12px 8px 12px;
  font-size: 13px;
}
.bulk-bar__count {
  color: #c0392b;
  font-weight: 600;
}
.bulk-bar__clear {
  background: transparent;
  border: 1px solid #ccc;
  border-radius: 4px;
  padding: 4px 10px;
  color: #666;
  cursor: pointer;
  font-size: 12px;
}
.bulk-bar__clear:hover { background: #f5f5f5; color: #061d47; border-color: #061d47; }
.bulk-bar__spacer { flex: 1; }
.bulk-bar__delete {
  background: #c0392b;
  color: #fff;
  border: 1px solid #c0392b;
  border-radius: 4px;
  padding: 6px 14px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.bulk-bar__delete:hover { background: #a52f23; border-color: #a52f23; }

.bulk-list {
  max-height: 300px;
  overflow-y: auto;
  font-size: 12px;
}
.bulk-list__row {
  display: grid;
  grid-template-columns: 1fr 1fr 80px;
  gap: 10px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f0f0;
}
.bulk-list__row:last-child { border-bottom: none; }
.bulk-list__name {
  color: #061d47;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bulk-list__owner {
  color: #666;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bulk-list__id {
  color: #888;
  font-size: 11px;
  text-align: right;
}

.tenant-delete-btn {
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.02em;
  color: #c0392b;
  background: transparent;
  border: 1px solid #e0b3ad;
  border-radius: 4px;
  padding: 3px 10px;
  cursor: pointer;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.tenant-delete-btn:hover {
  background: #c0392b;
  color: #fff;
  border-color: #c0392b;
}
.tenant-delete-btn:focus-visible {
  outline: 2px solid #061d47;
  outline-offset: 2px;
}

.td-modal-backdrop {
  position: fixed;
  inset: 0;
  background: rgba(6, 29, 71, 0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 16px;
}

.td-modal {
  background: #fff;
  border-radius: 10px;
  width: 100%;
  max-width: 600px;
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.28);
  overflow: hidden;
}

.td-modal__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 22px 28px;
  border-bottom: 1px solid #ececec;
}
.td-modal__head h2 {
  font-size: 18px;
  font-weight: 600;
  color: #c0392b;
  margin: 0;
  letter-spacing: 0.01em;
}
.td-modal__close {
  background: transparent;
  border: none;
  font-size: 24px;
  line-height: 1;
  color: #888;
  cursor: pointer;
  padding: 4px 8px;
  border-radius: 4px;
}
.td-modal__close:hover { color: #061d47; background: #f5f5f5; }

.td-modal__body {
  padding: 24px 28px 8px 28px;
  overflow-y: auto;
}
.td-modal__foot {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  padding: 18px 28px;
  border-top: 1px solid #ececec;
  background: #fafafa;
}

.td-warn {
  font-size: 13px;
  line-height: 1.55;
  color: #4a4a4a;
  background: #fff5f3;
  border: 1px solid #f1c4bd;
  border-radius: 6px;
  padding: 14px 16px;
  margin: 0 0 22px 0;
}
.td-warn strong { color: #c0392b; }

.td-target {
  border: 1px solid #ececec;
  border-radius: 6px;
  padding: 16px 18px;
  margin-bottom: 22px;
  font-size: 13px;
  background: #fafbfc;
}
.td-target__row {
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 5px 0;
}
.td-target__row + .td-target__row {
  border-top: 1px solid #f0f0f0;
}
.td-target__label {
  flex: 0 0 92px;
  color: #888;
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  font-weight: 600;
}
.td-target__val { color: #061d47; font-weight: 500; }
.td-target__sub { color: #888; font-weight: 400; margin-left: 4px; }
.td-target__val.mono { font-family: monospace; font-size: 12px; }

.td-preview {
  font-size: 13px;
  border: 1px solid #ececec;
  border-radius: 6px;
  padding: 16px 18px;
  margin-bottom: 22px;
}
.td-preview--loading { color: #888; font-style: italic; }
.td-preview__title {
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #888;
  font-weight: 600;
  margin-bottom: 10px;
}
.td-preview__list {
  list-style: disc;
  padding-left: 22px;
  margin: 0;
}
.td-preview__list li { padding: 3px 0; color: #061d47; }
.td-preview__sub { color: #888; font-weight: 400; margin-left: 4px; }

.td-field { display: block; margin-bottom: 20px; }
.td-field__label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #2a2a2a;
  margin-bottom: 8px;
}
.td-field__hint {
  display: inline-block;
  background: #f0f0f0;
  padding: 2px 8px;
  border-radius: 3px;
  margin-left: 6px;
  font-size: 12px;
  font-weight: 400;
}
.td-input,
.td-textarea {
  width: 100%;
  font-size: 14px;
  font-family: inherit;
  padding: 11px 14px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background: #fff;
  color: #061d47;
  box-sizing: border-box;
}
.td-input:focus,
.td-textarea:focus {
  outline: none;
  border-color: #061d47;
  box-shadow: 0 0 0 3px rgba(6, 29, 71, 0.12);
}
.td-textarea { resize: vertical; min-height: 70px; }

.td-progress {
  font-size: 13px;
  color: #666;
  font-style: italic;
  margin-top: 10px;
  padding: 10px 14px;
  background: #f5f5f5;
  border-radius: 5px;
}
.td-error {
  font-size: 13px;
  color: #c0392b;
  background: #fff5f3;
  border: 1px solid #f1c4bd;
  border-radius: 5px;
  padding: 12px 14px;
  margin-top: 12px;
}

.td-btn {
  font-size: 13px;
  font-weight: 600;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background-color 0.12s ease, color 0.12s ease, border-color 0.12s ease;
}
.td-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.td-btn--ghost {
  background: #fff;
  color: #061d47;
  border-color: #ccc;
}
.td-btn--ghost:hover:not(:disabled) { background: #f5f5f5; }
.td-btn--danger {
  background: #c0392b;
  color: #fff;
  border-color: #c0392b;
}
.td-btn--danger:hover:not(:disabled) { background: #a52f23; border-color: #a52f23; }
</style>
